import { ViewModelMessage } from "binder";

export class LocalNotificationMessage extends ViewModelMessage{
    process(addon: LocalNotification, connection: any):Promise<any>{
        return Promise.resolve();
    }
}

export class SendToLocalNotificationMessage extends LocalNotificationMessage{
    public command:string;
    public parameter:Object;
    constructor(command:string,parameter:object) {
        super();
        this.command = command;
        this.parameter = parameter;
    }

    process(localConnection: LocalNotification, connection: any):Promise<any>{
        try{
            connection.batisPushNotificationHub.server[this.command](JSON.stringify(this.parameter));
            return Promise.resolve();
        }catch(e){
            return Promise.reject();
        }
    }
}
export class RegisterForLocalNotification extends LocalNotificationMessage{
    public command:string;
    public eventListenner:(command:string,parameter:Object)=>void;

    constructor(command:string,listenner:(command:string,parameter:Object)=>void) {
        super();
        this.command = command;
        this.eventListenner = listenner;
    }

    process(localConnection: LocalNotification, connection: any):Promise<any>{
        localConnection._eventMultiplexer.addListenner(this.command,this.eventListenner);
        return Promise.resolve();
    }
}
export class UnregisterForLocalNotification extends LocalNotificationMessage{
    public command:string;
    public eventListenner:(command:string,parameter:Object)=>void;

    constructor(command:string,listenner:(command:string,parameter:Object)=>void) {
        super();
        this.command = command;
        this.eventListenner = listenner;
    }
    
    process(localConnection: LocalNotification, connection: any):Promise<any>{
        localConnection._eventMultiplexer.removeListenner(this.command,this.eventListenner);
        return Promise.resolve();
    }
}

class EventMultiplexer{
    private _map : {[id:string]:[(command:string,parameter:Object)=>void]}={}
    constructor() {
        
    }
    private removeItemAll(arr, value) {
        var i = 0;
        while (i < arr.length) {
            if (arr[i] === value) {
                arr.splice(i, 1);
            } else {
                ++i;
            }
        }
        return arr;
    }
    raise(command:string,parameter:object){
        if(this._map[command]!=undefined){
            this._map[command].forEach(x=>x(command,parameter));
        }
    }
    public addListenner(command:string,callback:(command:string,parameter:Object)=>void){
        if(this._map[command]==undefined){
            this._map[command]=<any>[];
        }
        this._map[command].push(callback)
    }
    public removeListenner(command:string,callback:(command:string,parameter:Object)=>void){
        this.removeItemAll(this._map[command],callback);
    }
}
export class LocalNotification{
    private _connectionTimer;
    private _isConnected:boolean;
    private _connection;
    public _eventMultiplexer : EventMultiplexer;
    private username:()=>string;
    private password:()=>string;
    constructor(username:()=>string,password:()=>string) {
        this._isConnected = false;
        this._eventMultiplexer = new EventMultiplexer();
        this.username = username;
        this.password = password;
        this.tryConnect();   
        
    }

    private async tryConnect(){
        try{
            await this.connect();
        }catch(e){
            this.addonNotFound();
            this.onConnectionLost();
        }

    }

    addonNotFound(){

    }
    addonConnected(){

    }
    public static async sendPdfPrint(pdfFile:string):Promise<string>{
        await fetch(LocalNotification.localServerUrl,{
            method:"POST",
            body:JSON.stringify({
                ReportFormName:"Pdf",
                FileContent : pdfFile
            })
        });
        return Promise.resolve<string>("");
    }
    public static async sendDesignReport(structure:string,reportContent:string,newEngine:int){
        let response = await fetch(LocalNotification.localServerUrl,{
            method:"POST",
            body:JSON.stringify({
                Mode:"Design",
                Report:reportContent ?? "",
                ReportStructure:structure,
                Engine : newEngine
            })
        });
        return response;
    }
    public static async sendRunReport(content:string,structure:string,data:any,engine:number,copyCount:number):Promise<string>{
        await fetch(LocalNotification.localServerUrl,{
            method:"POST",
            body:JSON.stringify({
                Mode:"Run",
                Report:content,
                ReportStructure:structure,
                CopyCount : copyCount,
                ReportData : data,
                Engine : engine
            })
        });
        return Promise.resolve<string>("");
    }
    private static localServerUrl:string =""; 
    private async connect(){
        // let url = "/signalr";
        for(let i=63000;i<63200;i++){
            try{
                let url = `http://localhost:${i}/signalr`;
                await this.connectPromise(url);
                this.setupConnection(url);
                // LocalNotification.localServerUrl = `http://localhost:${i+1}`;
                LocalNotification.localServerUrl = `http://localhost:${i+1}`;
                this.addonConnected();
                return;
            }
            catch(ex){
                console.log(ex);
            }
        }
        this.onConnectionLost();
        throw "Url Not Found";
    }

    private connectPromise(url:string):Promise<string>{
        let promise = new Promise<string>((resolve,reject)=>{
            $.getScript({
                url:`${url}/hubs`,
                success : x=>{
                    resolve(url)
                }
            })
            .fail(x=>{
                reject("Error");
            });

            // $.getScript(`${url}/hubs`,x=>{
            // }).fail(x=>{
            //     reject("Error");
            // })
        });
        return promise;
    }

    private setupConnection(url){
        try{
            let connection = (<any>$).hubConnection(url);
            connection.batisPushNotificationHub=connection.createHubProxies().batisHub;
            this.setupEvents(connection);
            connection.qs={Username:this.username(),Password:this.password()};
            connection.start()
                .done(()=>{
                    this._connection = connection; 
                    this._isConnected=true;
                })
                .fail(()=>this.onConnectionLost());
            connection.disconnected(()=>this.onConnectionLost());
        }catch(e){
            this.onConnectionLost();
        }
    }
    private setupEvents(connection){
        connection.batisPushNotificationHub.client.NewPushNotification = (username,command,parameter)=>{
            this._eventMultiplexer.raise(command,JSON.parse(parameter));
        };
    }

    private onConnectionLost(){
        console.log("reconnecting");
        this._isConnected = false;
        clearTimeout(this._connectionTimer);
        this._connectionTimer = setTimeout(x=>this.tryConnect(),1000);
    }
    async handleMessage(msg: LocalNotificationMessage) {
        return await msg.process(this,this._connection); 
    }
}

export class AddonNotFoundMessage extends ViewModelMessage{

}